import { Controller } from "@hotwired/stimulus"

const TARGET_FIELD_FOR_TRIGGER_TYPE = {
  location_visit: "locationVisitField",
  beacon_proximity: "beaconProximityField",
  nfc_scan: "nfcScanField"
}

const TARGET_FIELD_NAMES = ["locationVisitField", "beaconProximityField", "nfcScanField"]

// Connects to data-controller="points-award-form"
export default class extends Controller {
  static targets = [
    "triggerType",
    "locationVisitField",
    "beaconProximityField",
    "nfcScanField",
    "pointsThresholdField",
    "repeatable",
    "minimumIntervalField"
  ]

  connect() {
    this.update()
  }

  update() {
    const triggerType = this.triggerTypeTarget.value
    const activeField = TARGET_FIELD_FOR_TRIGGER_TYPE[triggerType]

    TARGET_FIELD_NAMES.forEach(fieldName => {
      const isActive = fieldName === activeField
      const wrapper = this[`${fieldName}Target`]
      wrapper.classList.toggle("hidden", !isActive)

      // Switching trigger_type moves a target's group out of view - untick its
      // triggers rather than disabling the fields, so an existing (persisted)
      // trigger's inverted `_destroy` checkbox still submits and gets cleaned
      // up server-side instead of silently surviving as a mismatched row.
      if (!isActive) {
        wrapper.querySelectorAll('input[type="checkbox"]').forEach(checkbox => { checkbox.checked = false })
      }
    })

    const isPointsThreshold = triggerType === "points_threshold"
    this.pointsThresholdFieldTarget.classList.toggle("hidden", !isPointsThreshold)
    this.pointsThresholdFieldTarget.querySelectorAll("input").forEach(input => { input.disabled = !isPointsThreshold })

    const isRepeatable = this.repeatableTarget.checked
    this.minimumIntervalFieldTarget.classList.toggle("hidden", !isRepeatable)
    this.minimumIntervalFieldTarget.querySelectorAll("select").forEach(select => { select.disabled = !isRepeatable })
  }
}
